const adjustThumbnailSizeDefaults = { widthParam: 'w', heightParam: 'h' };

// eslint-disable-next-line import/prefer-default-export
const adjustThumbnailSize = (thumbnailUrl, { height, width }, options) => {
  const { widthParam, heightParam } = options || adjustThumbnailSizeDefaults;
  try {
    const url = new URL(thumbnailUrl);
    if (height) {
      url.searchParams.set(heightParam, height);
    }
    if (width) {
      url.searchParams.set(widthParam, width);
    }
    return url.toString();
  } catch (err) {
    return null;
  }
};

// Will return the proxified url if necessary
// or the original url if not.
const getProxiedUrl =
  (originalUrl, proxyHost) => {
    try {
      const url = new URL(originalUrl);
      const { host, pathname } = url;
      url.pathname = `${host}${pathname}`;
      url.host = proxyHost;
      return url.toString();
    } catch {
      // URL constructor will throw error if invalid URL is given.
      // Returning the originalUrl as a fallback in this case.
      return originalUrl;
    }
  };

module.exports = {
  adjustThumbnailSize,
  getProxiedUrl,
};
